import React from "react";
import { Grid } from "@mui/material";
// import {



// } from "../../../common";
import UserGroups from "./user_groups/UserGroups";
import Roles from "./roles/Roles";
import AccesPermmision from "./access_permissions/AccessPermissions";

// import UserRoles from "./user-roles/UserRoles";
// import PolicyManagement from "./policy-management/PolicyManagement";


// =========================================================================================================
const ParentApplicationManagement = React.memo((props) => {
    // const [value, setValue] = React.useState(0);
    // const handleChange = (event, newValue) => {
    //   setValue(newValue);
    // };

    // const tabsName = [
    //   {
    //     name: "User Access",
    //   },
    // ];

    // const tabsData = [
    //   {
    //     name: "User Access",
    //     components: [
    //       { component: <UserRoles />, xl: 12, md: 12, lg: 12 },
    //       { component: <PolicyManagement />, xl: 12, md: 12, lg: 12 },
    //     ],
    //   },
    // ];

    try {
        return (
            <Grid spacing={2} container>
                {/* <TabsLayout
            backgroundColor=""
            customWidth="13rem"
            value={value}
            handleChange={handleChange}
            tabNames={tabsName}
            matchingValue={[0, 1, 2, 3, 4]}
          />
          <TabPanelLayout value={value} index={0} tabsData={tabsData} /> */}
                <Grid item xs={12} sm={12} md={6} >
                    <UserGroups />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    < Roles />
                </Grid>
                <Grid item xs={12}>
                    < AccesPermmision back={props?.back} />
                </Grid>
            </Grid>
        );
    } catch (err) {
        // return <CommonErrorMessage />;
    }
});

export default ParentApplicationManagement;
